export default __webpack_public_path__ + "static/media/joystick.4e1c0330.png";